import axios from 'axios';
import { ALO_API_HOST } from './constants';

export const FIND_IN_STORE_LAT_LONG = 'find_in_store_lat_long';
export const FIND_IN_STORE_POSTAL_CODE = 'find_in_store_postal_code';

export const getGeocode = async (params: GeocodeParams) => {
  return await axios
    .get(`${ALO_API_HOST}/v1/geocode`, { params })
    .then(({ data }) => data)
    .catch((err: Error) => {
      throw err;
    });
};

export const checkStoreAvailability = async (params: StoreAvailabilityParams) => {
  return await axios
    .get(`${ALO_API_HOST}/v1/store_availability`, { params })
    .then(({ data }) => data)
    .catch((err: Error) => {
      throw err;
    });
};

interface GeocodeParams {
  postal_code: string;
  country_code: string;
}

export interface StoreAvailabilityParams {
  sku: string;
  latitude: number;
  longitude: number;
  limit?: number;
}

export interface LatLng {
  latitude: number;
  longitude: number;
}
